<template>
  <el-autocomplete
    ref="branch"
    placeholder="Buscar sucursal..."
    v-model="branchSearch.name"
    :fetch-suggestions="querySearchAsync"
    @select="handleSelect"
    @clear="clear"
    :trigger-on-focus="false"
    clearable
    size="normal"
    style="width: 100%"
  >
    <template slot="prepend"><i class="el-icon-s-shop"></i></template>
      <template slot-scope="{ item }">
        <div class style="line-height: 1; padding: 5px 0 5px">
          <i class="mdi mdi-account"></i>
          {{ item.razon_social }}
          <br />
          <small>
            <i class="mdi mdi-clipboard-account"></i>
            {{ item.direccion }}
          </small>
        </div>
      </template>
  </el-autocomplete>
</template>

<script>
import { searchBranch } from "@/api/branch"
export default {
  data(){
    return {
      branchSearch: {
        id: (this.default) ? this.default.id : null,
        name: (this.default) ? this.default.razon_social : null,
        phone: (this.default) ? this.default.celular : null,
        meta: (this.default) ? this.default.meta_data : null,
        direction: (this.default) ? this.default.direccion : null,
      }
    }
  },
  props:['default'],
  watch: {
    default: function (val) {
      if(val)
        this.branchSearch = {
          id: val.id,
          name: val.razon_social,
          phone: val.celular,
          meta: val.meta_data,
          direction: val.direccion,
        }     
    }
  },
  methods: {
    querySearchAsync(queryString, cb) {
      if (queryString && queryString.length > 3) {
        searchBranch(queryString)
          .then(({ data }) => {
            cb(data.data);
          })
          .catch((error) => {
            this.$message.error('Error al buscar sucursal')
            console.log(error);
          });
      }
    },
    handleSelect(item) {
      this.branchSearch = {
        id: item.id,
        name: item.razon_social,
        phone: item.celular,
        meta: item.meta_data,
        direction: item.direccion,
      }
      this.$emit('select', item)
    },
    clear() {
      this.$emit('clear')
    },
  },
}
</script>